import { useEffect, useRef, useState } from "react";

const CountDownView = ({ startFrom, onCountdownEnd }) => {
  const [value, setValue] = useState(startFrom);
  const startTimeRef = useRef(Date.now());
  const lastElapsedSec = useRef(0);

  useEffect(() => {
    let timer;
    if (value <= 0) {
      setTimeout(() => { onCountdownEnd() }, 300);
    } else {
      timer = value > 0 && setInterval(() => {
        let elapsedSofarSec = Math.floor((Date.now() - startTimeRef.current) / 1000);
        let remainingSec = elapsedSofarSec - lastElapsedSec.current;
        lastElapsedSec.current = elapsedSofarSec;

        let currentvalue = value - remainingSec;
        if (currentvalue < 0) {
          currentvalue = 0;
        }
        setValue(currentvalue);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [value]);

  return (<>{ "0:"+value }</>);
};
export default CountDownView;